export default __webpack_public_path__ + "static/media/tapicerowane13.d266d027.jpg";